import { Provider } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Globals } from 'app/shared/configuration/globals';
import { AuthService } from 'app/tinea-components/okta/auth/auth.service';
import { AuthentWithCustomOktaService } from 'app/tinea-components/okta/auth/services/authent-with-custom-okta.service';
import { LoggedInService } from 'app/tinea-components/okta/services/loggedIn.service';
import { LoggedInAuthentService } from 'app/tinea-components/okta/services/loggedInAuthentservice';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

export const provideAppLegacyServices = (): Provider[] => [
  Globals,
  Title,
  MessageService,
  DialogService,
  { provide: AuthService, useClass: AuthentWithCustomOktaService },
  { provide: LoggedInService, useClass: LoggedInAuthentService },
];
